// extracted by mini-css-extract-plugin
module.exports = {"innerBanner":"InnerBanner_innerBanner__3QDrW","bannerTitle":"InnerBanner_bannerTitle__3DW0Q"};